//build step builds into lib folder
module.exports = require('./lib')
